import { oLocalStorage } from "./EncodedLocalStorage";

export function signIn(oData, bSaveCustIdInSession = false) {
  if (oData.cAccessToken) {
    localStorage.setItem('cAccessToken', oData.cAccessToken);
  }
  localStorage.setItem('cStorageToken', oData.cStorageToken ?? oData);
  oLocalStorage.decodeToken();
  if (oLocalStorage.get("cAccessToken")) {
    localStorage.setItem('cAccessToken', oLocalStorage.get("cAccessToken"));
  }

  const nCustIdOld = +sessionStorage.getItem('nCustId');
  if (nCustIdOld && nCustIdOld !== oLocalStorage.get("nCustId")) {
    window.location.href = '/';
  }

  if (bSaveCustIdInSession) {
    sessionStorage.setItem('nCustId', oLocalStorage.get("nCustId"));
    sessionStorage.setItem('cOldCompanyName', oLocalStorage.get("cCompanyName"));
    sessionStorage.setItem('cOldCompanyCNPJ', oLocalStorage.get("cCompanyCNPJ"));
  }
}

export function signOut() {
  localStorage.removeItem('cAccessToken');
  oLocalStorage.destroy();

  sessionStorage.removeItem('nCustId');
  sessionStorage.removeItem('cOldCompanyName');
  sessionStorage.removeItem('cOldCompanyCNPJ');
}
